import md5 from 'md5';
import { usePermissionStoreWithOut } from '@/store/modules/permission';

const toString = Object.prototype.toString

/**
 * MD5加密 
 */
export const encryption = (value)=>{
    return md5(value);
};

/**
 * 检查数据类型
 * @param value 
 * @param type 
 * @returns 
 */
 export const is = (value,type)=>{
    return toString.call(value) === `[object ${type}]`
}

/**
 * 检查是否为undefined
 * @param value 
 * @returns 
 */
 export const isDef = (value)=>{
    return typeof value !== 'undefined'
}

/**
 * 检查数据类型是否为object
 * @param value 
 * @returns 
 */
export const isObject = (value)=>{
    return value !== null && is(value, 'Object')
}

/**
 * 检查数据类型是否为数字
 * @param value 
 * @returns 
 */
export const isNumber = (value)=>{
    return is(value, 'Number')
}

/**
 * 检查数据类型是否为字符串
 * @param value 
 * @returns 
 */
export const isString = (value)=>{
    return is(value, 'String')
}

/**
 * 检查数据类型是否为函数
 * @param value 
 * @returns 
 */
export const isFunction = (value)=>{
    return typeof value === 'function'
}

/**
 * 检查数据类型是否为布尔类型
 * @param value 
 * @returns 
 */
export const isBoolean = (value)=>{
    return is(value, 'Boolean')
}

/**
 * 检查数据类型是否为数组
 * @param value 
 * @returns 
 */
export const isArray = (value)=>{
    return value && Array.isArray(value)
}

/**
 * 检查用户是否权限
 * @param string|array value 
 * @returns bool
 */
export const isAuth = (value)=>{
    const permissionStore   = usePermissionStoreWithOut();
    const auth              = permissionStore.auth;
    const purview           = '*';

    if(isArray(auth) && value.length > 0){
        return auth.some((key)=>{
            return purview == key || value.includes(key);
        });
    }

    return false;
}

/**
 * 判断一个值是否在数组中
 * @param search 要搜索的值
 * @param array  被搜索的数组
 * @returns 
 */
export const inArray = (search,array)=>{
	let flag = false;
	for(let i in array){
		if(array[i]==search){
			flag = true;
			break;
		}
	}

	return flag;
}

/**
 * 检查数据是否为空
 * @param value 
 * @returns 
 */
export const isEmpty = (value)=>{
    if(value == null || value == undefined){
        return true;
    }

    if (isArray(value) || isString(value)) {
        return value.length === 0
    }
    
    if (value instanceof Map || value instanceof Set) {
        return value.size === 0
    }

    if (isObject(value)) {
        return Object.keys(value).length === 0
    }
    
    return false
}

/**
 * 检查数据是否为Map
 * @param value 
 * @returns 
 */
export const isMap = (value)=> {
    return is(value, 'Map')
}

export function isIOS(){
	return !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
}

/**
 * 去除左边字符串中某个字符串
 * @param str 
 * @param char 
 * @returns 
 */
 export const ltrim = (str,char)=>{
	let pos = str.indexOf(char);
	let sonstr = str.substr(pos+1);
	return sonstr;
}

/**
 * 去除右边字符串中某个字符串
 * @param str 
 * @param char 
 * @returns 
 */
export const rtrim = (str,char)=>{
	let pos = str.lastIndexOf(char);
	let sonstr = str.substr(0,pos);
	return sonstr;
}

/**
 * 去除前后字符串中空格
 * @param str
 * @returns 
 */
export const trim = (str)=>{
    return str.trim();
}

/**
 * 深拷贝
 * @param source
 * @returns
 */
export function deepClone(source) {
    if (!source && typeof source !== "object") {
        return source;
    }

    const targetObj = source.constructor === Array ? [] : {};
    Object.keys(source).forEach((keys) => {
        if (source[keys] && typeof source[keys] === "object") {
            (targetObj)[keys] = deepClone(source[keys]);
        } else {
            (targetObj)[keys] = source[keys];
        }
    });

    return targetObj;
}

/**
 * 深度合并
 * @param src
 * @param target
 * @returns
 */
export const deepMerge = (src={},target={})=>{
    let key;
    for (key in target) {
        src[key] = isObject(target[key]) ? deepMerge(src[key], target[key]) : (src[key] = target[key]);
    }
    return src;
}

/**
 * 复制到剪贴板
 * @param string content 
 */
export const copyToClipboard = (content)=> {
    if (window.clipboardData) {
        window.clipboardData.setData("text", content);
    } else {
        (function (content) {
            document.oncopy = function (e) {
                e.clipboardData.setData("text", content);
                e.preventDefault();
                document.oncopy = null;
            };
        })(content);
        document.execCommand("Copy");
    }
}

/**
 * 检查用户是否使用手机访问
 * @returns bool
 */
export const isMobile = ()=>{
    return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
}